import { render, staticRenderFns } from "./FacebookCampaignSummary.vue?vue&type=template&id=12d4a79d&scoped=true&lang=pug"
import script from "./FacebookCampaignSummary.js?vue&type=script&lang=js&external"
export * from "./FacebookCampaignSummary.js?vue&type=script&lang=js&external"
import style0 from "./FacebookCampaignSummary.sass?vue&type=style&index=0&id=12d4a79d&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4a79d",
  null
  
)

export default component.exports